export default "__VITE_PUBLIC_ASSET__6af2d33c__"